module.exports = __webpack_public_path__ + "static/below-c-level-42cbf0c07a0a0be0805cbacc99a44281.svg";